module.exports = __webpack_public_path__ + "static/media/31.5c9be0d0.png";